module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'input-text',
      _vm.hasFocus ? 'input-text--focus' : '',
      _vm.hasFocus || _vm.currentValue ? 'input-text--reveal-value' : ''
    ]
  }, [(_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.hasFocus = true
      },
      "blur": function($event) {
        _vm.hasFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.hasFocus = true
      },
      "blur": function($event) {
        _vm.hasFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    attrs: {
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.hasFocus = true
      },
      "blur": function($event) {
        _vm.hasFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "input-text-c"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-text-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-text-underline"
  }, [_c('div', {
    staticClass: "input-text-underline-active"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36b97384!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/InputText.vue
// module id = 485
// module chunks = 2